import Page from '../../page';
import ListAsyncManager,  { AsyncListManagerEvent } from "../../../helpers/asyncListManager/AsyncListManager";
import QueryURLBuilder from '../../../helpers/query-url-builder';
import {SelectEvent} from "../../../components/select/select";
import Shutter from "../../../helpers/shutter";

export default class ReferencesList extends Page {

    constructor(...args) {
        super(...args);

        bindAll( this, [
            '_clickLoadMore',
            '_changeSelectFilter',
            '_clickResetFilter',
        ]);

        this._retrieveDOM();
        this._initTls();
    }

    _retrieveDOM() {
        this.dom.views = {};

        this.dom.views.container = this.dom.page.querySelector('.js-references-list-container');
        this.dom.views.btnLoadMore = this.dom.page.querySelector( '.js-load-more' );
        this.dom.views.results = this.dom.page.querySelector('.js-references-list');

        this.dom.views.filters = {};
        this.dom.views.filters.container = this.dom.page.querySelector('.ct--references-filters');
        this.dom.views.filters.selectFilters = this.dom.views.filters.container.querySelectorAll('.js-filter');
        this.dom.views.filters.reset = this.dom.views.filters.container.querySelector('.js-filter-reset');
    }

    init() {
        super.init();

        this._filters = {};
        this._filtersSlug = {};

        this._QueryURLBuilder = new QueryURLBuilder();

        // Retrieve the values ​​of the filters selected by default (id and slug)
        if( Object.keys( dataFiltersSelected ).length > 0 ) {

            for ( let filterDefault in dataFiltersSelected ) {
                this._filters[ filterDefault ] = parseInt( dataFiltersSelected[ filterDefault ]['id'] );
                this._filtersSlug[ filterDefault ] = dataFiltersSelected[ filterDefault ]['slug'];
            }

            // if the parameters in the URL are not already present (case filter by default ==> company) : we put the parameters in the url
            if( Object.keys( this._QueryURLBuilder.getQueryParams() ).length == 0 ) {
                this._QueryURLBuilder.serialize( this._filtersSlug );
            }
        }

        // For all other unselected filters: set the values ​​to null in the corresponding tables
        for(let i = 0, j = dataNameFilter.length; i < j; i++) {

            if( !this._filters.hasOwnProperty( dataNameFilter[i] ) )
                this._filters[ dataNameFilter[i] ] = null;

            if( !this._filtersSlug.hasOwnProperty( dataNameFilter[i] ) )
                this._filtersSlug[ dataNameFilter[i] ] = null;
        }

        this._action = 'bbi_reference_get_posts_ajax';
        this._ALM = new ListAsyncManager( this._action, this.dom.views.btnLoadMore );
        this._locked = false;
    }

    bind() {
        super.bind();

        // Click Filters
        if( this.dom.views.filters.selectFilters ) {
            // for(let i = 0, j = this.dom.views.filters.selectFilters.length; i < j; i++ ) {
            //     this.dom.views.filters.selectFilters[i].addEventListener( 'change', this._changeSelectFilter );
            // }
            if ( this.Components.hasOwnProperty( 'Select' ) ) {
                for(let i = 0, j = this.Components.Select.length; i < j; i++) {
                    this.Components.Select[i].on( SelectEvent.SELECT_CHANGE, this._changeSelectFilter );
                }
            }
        }

        // Click Reset
        if( this.dom.views.filters.reset )
            this.dom.views.filters.reset.addEventListener( 'click', this._clickResetFilter );

        // Click button "load more"
        if( this.dom.views.btnLoadMore )
            this.dom.views.btnLoadMore.addEventListener( 'click', this._clickLoadMore );

        // Data receive
        this._ALM.on( AsyncListManagerEvent.UPDATED, ( xhr ) => {

            this._injectData( xhr );

            // Update URL according filters selected
            this._QueryURLBuilder.serialize( this._filtersSlug );
        } );
    }

    /**
     * Called when user click on a filter select
     * @param {Object} event - Data passed by the event 'SelectEvent.SELECT_CHANGE' (in 'Select' class)
     * @private
     */
    _changeSelectFilter( event ) {
        this._processFilter( event.currentTarget, event.slug );
    }

    /**
     * Called when user click on the reset filter button
     * @param {Event} event - Click event
     * @private
     */
    _clickResetFilter( event ) {
        if( this.dom.views.filters.reset.classList.contains('lock-reset') )
            return;
        this.dom.views.filters.reset.classList.add('lock-reset');
        this._resetFilters();
    }

    /**
     * Reset all filters to get all the references
     * @private
     */
    _resetFilters() {

        // for(var i = 0, j = this.dom.views.filters.selectFilters.length; i < j; i++) {
        //     this.dom.views.filters.selectFilters[i].classList.remove('active');
        //     //this.dom.views.filters.selectComponent.reset();
        // }

        // Reset all selects from their components
        if ( this.Components.hasOwnProperty( 'Select' ) ) {
            const selectComponents = this.Components.Select;
            for( let i = 0, j = selectComponents.length; i < j; i++ ) {
                selectComponents[i].reset();
            }
        }

        // Reset filter id array
        for (let filter in this._filters) {

            if ( this._filters.hasOwnProperty( filter ) ) {
                this._filters[ filter ] = null;
            }
        }

        // Reset filter slug array
        for (let filterSlug in this._filtersSlug) {

            if ( this._filtersSlug.hasOwnProperty( filterSlug ) ) {
                this._filtersSlug[ filterSlug ] = null;
            }
        }

        // Reset URL
        this._QueryURLBuilder.serialize( this._filtersSlug );

        // Retrieve
        this._ALM.load( this._filters );
    }

    /**
     * Displays the references based on the clicked filter (set filters array (filter id and filter slug) and make request Ajax)
     * @param {Element DOM} filter - the select filter that was clicked
     * @param {string} slug - the slug of the selected filter
     * @private
     */
    _processFilter( filter, slug ) {

        console.log('process filter');

        if( this._locked == false ) {

            this._locked = true;

            let id = parseInt( filter.value);
            let name_filter = filter.getAttribute( 'data-name-filter' );

            if( this._filters.hasOwnProperty( name_filter ) ) {

                if( this._filters[ name_filter ] == id || ( ( isNaN( id ) || id == 0 ) && this._filters[ name_filter ] == null ) )
                    return;

                // Filter already active => disable it
                if( isNaN( id ) || id == 0 ) {
                    //filter.classList.remove( 'active' );
                    this._filters[ name_filter ] = null;
                    this._filtersSlug[ name_filter ] = null;
                } else {
                    //filter.classList.add( 'active' );
                    this._filters[ name_filter ] = id;
                    this._filtersSlug[ name_filter ] = slug;
                }

                // Select the "All element" button if there are selected filters or not
                this.dom.views.filters.reset.classList.add( 'lock-reset' );
                for ( let prop in this._filters ) {
                    if( this._filters[prop] != null ) {
                        this.dom.views.filters.reset.classList.remove( 'lock-reset' );
                        continue;
                    }
                }

                // Retrieve
                this._ALM.load( this._filters );

            } else {
                this._locked = false;
            }
        }
    }
    
    /**
     * Called when user click on button "load more"
     * @param {Event} event - Click event
     * @private
     */
    _clickLoadMore( event ) {

        if( this._locked == false ) {
            this._locked = true;
            this._ALM.loadMore( event );
        }
    }

    /**
     * Called when ajax request succeeded ( request for new news )
     * @param {JSON} xhr - Request's response
     * @private
     */
    _injectData( xhr ) {
        this._locked = false;

        // Check if there is result
        if(xhr.data.has_results == false) {
            this._toggleNoResult();
            this._hideLoadMore();
        } else {

            this.dom.views.container.classList.remove('no-results');

            // Check if there is other data to load
            if(xhr.data.load_more == true)
                this._showLoadMore();
            else
                this._hideLoadMore();

            // Insert new items
            if(xhr.data.page == 1) {
                this.dom.views.results.innerHTML = xhr.data.posts_html;
            } else {
                this.dom.views.results.insertAdjacentHTML( 'beforeend', xhr.data.posts_html );
            }

            // Display animation for new items
            this.newItems = document.querySelectorAll( '.to-animate' );
            for( let i = 0, j = this.newItems.length; i < j; i++ )
            {
                let delay = i * 110;
                this._animateResult(i, delay);
            }
        }
    }

    /**
     * Empty the result container (when no result)
     * @private
     */
    _toggleNoResult() {
        this.dom.views.container.classList.add('no-results');
        this.dom.views.results.innerHTML = '';
    }

    /**
     * Hide button load more
     * @private
     */
    _hideLoadMore() {
        if( this.dom.views.btnLoadMore )
            this.dom.views.btnLoadMore.classList.add('hidden');
    }

    /**
     * Show button load more
     * @private
     */
    _showLoadMore() {
        if( this.dom.views.btnLoadMore )
            this.dom.views.btnLoadMore.classList.remove('hidden');
    }

    /**
     * Display animation for new items to show
     * @param {Number} index - Target item to show
     * @param {Number} delay - Interval time between the animation of the elements
     * @private
     */
    _animateResult( index, delay ) {
        setTimeout(() => {
            this.newItems[ index ].classList.remove('to-animate');
        }, delay);
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// ./src/js/pages/references/list/references-list.js